/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../../Fixes';
import Builder from '../../../../../Builder';
import '../../resources/error';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "connect": {
        "nested": {
          "v2": {
            "nested": {
              "merchant_catalog": {
                "nested": {
                  "service": {
                    "nested": {
                      "CatalogObjectHistoryRequest": {
                        "fields": {
                          "objectId": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "updatedBefore": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          },
                          "limit": {
                            "type": "int32",
                            "id": 3,
                            "rule": "optional"
                          }
                        }
                      },
                      "ObjectChange": {
                        "fields": {
                          "timestamp": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "version": {
                            "type": "int64",
                            "id": 2,
                            "rule": "optional"
                          },
                          "connectAppId": {
                            "type": "string",
                            "id": 3,
                            "rule": "optional"
                          },
                          "employeeToken": {
                            "type": "string",
                            "id": 4,
                            "rule": "optional"
                          },
                          "userToken": {
                            "type": "string",
                            "id": 5,
                            "rule": "optional"
                          },
                          "service": {
                            "type": "string",
                            "id": 6,
                            "rule": "optional"
                          },
                          "method": {
                            "type": "string",
                            "id": 7,
                            "rule": "optional"
                          },
                          "principal": {
                            "type": "string",
                            "id": 8,
                            "rule": "optional"
                          },
                          "userAgent": {
                            "type": "string",
                            "id": 9,
                            "rule": "optional"
                          },
                          "remoteAddr": {
                            "type": "string",
                            "id": 10,
                            "rule": "optional"
                          },
                          "connectAppName": {
                            "type": "string",
                            "id": 11,
                            "rule": "optional"
                          },
                          "employeeName": {
                            "type": "string",
                            "id": 12,
                            "rule": "optional"
                          },
                          "source": {
                            "type": "int32",
                            "id": 13,
                            "rule": "optional"
                          }
                        }
                      },
                      "CatalogObjectHistoryResponse": {
                        "fields": {
                          "errors": {
                            "type": "squareup.connect.v2.resources.Error",
                            "id": 1,
                            "rule": "repeated"
                          },
                          "objectChange": {
                            "type": "squareup.connect.v2.merchant_catalog.service.ObjectChange",
                            "id": 2,
                            "rule": "repeated"
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.service?.nested?.CatalogObjectHistoryRequest && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.service?.nested?.ObjectChange && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.service?.nested?.CatalogObjectHistoryResponse) {
  $root.addJSON(jsonData);
}

/**
 * Hack Week 11/2023
 *
 * SOURCE CatalogObjectHistoryRequest @ squareup/connect/v2/catalog/interfaces/catalog-object-history.proto at 11:1
 */
export const CatalogObjectHistoryRequest = $root.lookupType('squareup.connect.v2.merchant_catalog.service.CatalogObjectHistoryRequest');
fixType(CatalogObjectHistoryRequest, {
  objectId: {
    required: true,
    notEmpty: true
  }
});
Builder.createAndAttachToType(CatalogObjectHistoryRequest);
/**
 * Hack Week 11/2023
 *
 * SOURCE ObjectChange @ squareup/connect/v2/catalog/interfaces/catalog-object-history.proto at 25:1
 */
export const ObjectChange = $root.lookupType('squareup.connect.v2.merchant_catalog.service.ObjectChange');
fixType(ObjectChange);
Builder.createAndAttachToType(ObjectChange);
/**
 * Hack Week 11/2023
 *
 * SOURCE CatalogObjectHistoryResponse @ squareup/connect/v2/catalog/interfaces/catalog-object-history.proto at 44:1
 */
export const CatalogObjectHistoryResponse = $root.lookupType('squareup.connect.v2.merchant_catalog.service.CatalogObjectHistoryResponse');
fixType(CatalogObjectHistoryResponse);
Builder.createAndAttachToType(CatalogObjectHistoryResponse);